module.exports = __webpack_public_path__ + "img/info-square.ac4148f9.svg";